import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTextField = styled(TextField)(() => ({
  flexGrow: 2,
  background: "white",
  borderRadius: "8px",
  fontWeight: "400",
  "& .MuiInputBase-root": {
    borderRadius: "8px",
    height: "100%",
  },
  "& .MuiInputBase-input": {
    height: "100%",
    fontSize: "17px",
    fontWeight: "400",
  },
  "& .MuiInputBase-input::placeholder": {
    fontSize: "16px",
    fontWeight: "400",
    color: "black",
  },
}));

export default StyledTextField;
